import { fmtRpShort } from "@/lib/format";

export const SECTION_LABEL = {
  pendapatan: "Pendapatan",
  beban: "Beban",
  aset: "Aset",
  liabilitas: "Liabilitas",
  ekuitas: "Ekuitas",
};

export const TX_LABEL = {
  jasa: "Jasa / management fee",
  sewa_bangunan: "Sewa tanah/bangunan",
  sewa_alat: "Sewa alat / harta lain",
  barang: "Penjualan barang",
};

export const REGIME_LABEL = { normal: "Tarif umum 22%", umkm_final: "PPh final 0,5%" };
export const ENTITY_LABEL = { pt: "PT", pt_perorangan: "PT Perorangan", cv: "CV", koperasi: "Koperasi" };

export const DEFAULT_PROFILE = {
  entity_type: "pt",
  regime: "normal",
  fasilitas_31e: true,
  is_pkp: true,
  ppn_rate: 12,
  ppn_dpp_nilai_lain: true,
  pph23_rate: 2,
  pph42_sewa_rate: 10,
  loss_carryforward: 0,
  registered_year: null,
};

export const rid = () => (crypto?.randomUUID ? crypto.randomUUID() : Math.random().toString(36).slice(2));

export function plTotals(items = []) {
  let rev = 0;
  let exp = 0;
  items.forEach((i) => {
    if (i.section === "pendapatan") rev += Number(i.amount) || 0;
    if (i.section === "beban") exp += Number(i.amount) || 0;
  });
  return { rev, exp, laba: rev - exp };
}

/**
 * Local preview of item movements (mirrors backend engine, without tax).
 * Returns { [companyId]: items[] } where items may carry flags: moved, intercompany, billed, remaining.
 */
export function applyTransfersLocal(companies, transfers) {
  const byId = Object.fromEntries(companies.map((c) => [c.id, c]));
  const state = Object.fromEntries(
    companies.map((c) => [
      c.id,
      (c.items || [])
        .filter((i) => i.section === "pendapatan" || i.section === "beban")
        .map((i) => ({ ...i, original: Number(i.amount) || 0, amount: Number(i.amount) || 0, remaining: Number(i.amount) || 0, billed: 0 })),
    ])
  );
  for (const t of transfers) {
    const a = byId[t.from_id];
    const b = byId[t.to_id];
    if (!a || !b || !state[a.id] || !state[b.id]) continue;
    const item = state[a.id].find((i) => i.id === t.item_id);
    if (!item) continue;
    const x = Number(t.amount) || 0;
    item.remaining -= x;
    if (t.mode === "realokasi") {
      item.amount -= x;
      const target = state[b.id].find((i) => i.name === item.name && i.section === item.section);
      if (target) {
        target.amount += x;
        target.remaining += x;
        target.moved = true;
      } else {
        state[b.id].push({ id: `mv-${t.id}`, section: item.section, name: item.name, amount: x, original: 0, remaining: x, fiscal: item.fiscal, moved: true, movedFrom: a.name, virtual: true });
      }
    } else if (item.section === "beban") {
      item.billed += x;
      state[a.id].push({ id: `ic-r-${t.id}`, section: "pendapatan", name: `Recharge ${item.name} ke ${b.name}`, amount: x, original: 0, remaining: 0, intercompany: true, virtual: true });
      state[b.id].push({ id: `ic-e-${t.id}`, section: "beban", name: `${item.name} (tagihan ${a.name})`, amount: x, original: 0, remaining: 0, intercompany: true, virtual: true });
    } else {
      item.billed += x;
      state[a.id].push({ id: `ic-e-${t.id}`, section: "beban", name: `Subkontrak ${item.name} ke ${b.name}`, amount: x, original: 0, remaining: 0, intercompany: true, virtual: true });
      state[b.id].push({ id: `ic-r-${t.id}`, section: "pendapatan", name: `${item.name} (subkontrak ${a.name})`, amount: x, original: 0, remaining: 0, intercompany: true, virtual: true });
    }
  }
  return state;
}

export const short = (v) => fmtRpShort(v);
